















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountGeneralDepositValues from '@/models/Accounts/DepositAccounts/Values/AccountGeneralDepositValues';

@Component({ name: 'AccountGeneralDepositValuesRead' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    values: AccountGeneralDepositValues;

}
